import React from 'react'
import { CBadge } from '@coreui/react-pro'

const MAP: Record<string, { color: string; label: string }> = {
  booked: { color: 'success', label: 'Booked' },
  planning: { color: 'warning', label: 'Planning' },
  needs_attention: { color: 'danger', label: 'Needs attention' },
  paid: { color: 'success', label: 'Paid' },
  owed: { color: 'warning', label: 'Owed' },
  settled: { color: 'secondary', label: 'Settled' },
  arrival: { color: 'info', label: 'Arrival' },
  departure: { color: 'secondary', label: 'Departure' },
}

const StatusBadge: React.FC<{ status?: string | null }> = ({ status }) => {
  if (!status) return null
  const cfg = MAP[status] ?? { color: 'secondary', label: status }
  return <CBadge color={cfg.color}>{cfg.label}</CBadge>
}

export default StatusBadge
